const experiences = [
    {
      year: 2024,
      title: 'Intern at Pathbeat',
      location: 'Bengaluru, Karnataka',
      position: 'React Native Developer',
      duration: 'June 2024 - Current',
      responsibilities: [
        {
          title: 'Product Development and Engineering',
          description: 'Engineered the app from the ground up using Redux, React Query, and React Hooks. Improved performance with lazy loading, memoization, and code splitting. Worked closely with designers and backend developers to ship the product.',
        },
        {
          title: 'API Development and Testing',
          description: 'Integrated and consumed REST APIs, including Google Auth. Designed and tested corner and edge cases to ensure smooth operation in all scenarios.',
        },
        {
          title: 'Advanced Feature Integration',
          description: 'Integrated third-party libraries and native modules. Developed custom animations, transitions, deep linking, Razorpay for payments, and caching to enhance user experience.',
        },
      ],
    },
    {
      year: 2024,
      title: 'Intern at Trainity',
      location: 'Bengaluru, Karnataka',
      position: 'Full Stack Web Developer',
      duration: 'Feb 2024 - April 2024',
      responsibilities: [
        {
          title: 'Backend Development',
          description: 'Developed and maintained REST APIs using Express.js and MongoDB. Implemented authentication and authorization with JWT and OAuth. Optimized database queries and backend performance, and ensured scalability and maintainability of codebase.',
        },
        {
          title: 'Frontend Development',
          description: 'Converted Figma designs into responsive React components using Material-UI and integrated backend APIs for seamless interaction.',
        },
      ],
    },
    {
      year: 2023,
      title: 'Intern at Acumensa Technologies',
      location: 'Bengaluru, Karnataka',
      position: 'Frontend Developer',
      duration: 'April 2023 - August 2023',
      responsibilities: [
        {
          title: 'Frontend Development',
          description: 'Developed complex React components for a B2C healthcare web solution, optimizing UI/UX for end users.',
        },
        {
          title: 'API Integration',
          description: 'Integrated APIs with efficient error handling and data management.',
        },
        {
          title: 'Collaboration',
          description: 'Worked with Delivery Lead, Backend, and QA teams, applying Agile methodologies for timely feature delivery.',
        },
      ],
    },
    {
      year: 2022,
      title: 'Tech Fest Lead at IIT Dharwad (Parsec)',
      location: 'IIT Dharwad',
      position: 'Web Development Team Lead',
      duration: 'Jan 2022 - March 2022',
      responsibilities: [
        {
          title: 'Tech Fest Lead',
          description: 'Led a team of 6 developers in creating a responsive MERN stack website for the college tech fest, ensuring project success.',
        },
      ],
    },
    {
      year: 2022,
      title: 'Inter IIT Tech Meet',
      location: 'IIT Kanpur',
      position: 'Bronze Medalist',
      duration: 'Feb 2022 - April 2022',
      responsibilities: [
        {
          title: 'Full Stack Developer',
          description: 'Built a sustainable and well-connected high-speed distribution network for e-commerce brands offering same-day delivery solutions. Played a key role in unlocking growth and simplifying scalability for these brands.',
        },
      ],
    },
  ];

  export default experiences